import IWorkOrderStatusViewModel from "interfaces/IWorkOrderStatusViewModel";

const AllocationTemplate = (props: IWorkOrderStatusViewModel): any => {
  const workOrder = { props };
  return (
    <>
      <span data-testid="workOrderAllocation" className="fw-bold">
        {workOrder.props.collectorName}
      </span>
      <br />
      <span>
        {workOrder.props.collectorType}
      </span>
    </>
  );
};
export default AllocationTemplate;
